import React from 'react';
import { Grid, Row, Col, Label } from '../utils/bootstrap';
import { Helmet } from 'react-helmet';
import MainImage, { InlineImage } from '../components/MainImage';

const styles = {
  name: {
    fontSize: '1.5em',
  },
  label: {
    cursor: 'pointer',
    padding: '.5em',
    backgroundColor: 'transparent',
  },
};

class ProductInfo extends React.Component {
  componentWillMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const { history } = this.props;

    return (
      <div>
        <Helmet>
          <title>About Us | Business Financing Solutions | Premium Capital Partners</title>
          <meta name="description" content="Premium Capital Partners was established with the goal of delivering pioneering business financing solutions to the Malaysian market." />
        </Helmet>
        <InlineImage
          img="/about.jpg"
          innerDivStyle={{ padding: '3% 0 1em' }}
          className="hidden-xs"
        >
          <div>
            <h2 style={{ maxWidth: '15em', fontSize: '2.8em' }}>About Premium Capital Partners</h2>
            <h1 style={{position: 'relative', color: 'white'}}>Business Financing Solutions</h1>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-around', width: '100%' }}>
            <Label style={styles.label}
                   onClick={() => history.push('/our-team/khoo-khay-teik')}><span style={styles.name}>Khoo Khay Teik</span><br />
              Chief Operating Officer</Label>
            <Label style={styles.label}
                   onClick={() => history.push('/our-team/christopher-koh')}><span style={styles.name}>Christopher Koh</span><br />
              Chairman, Supervisory Board</Label>
            <Label style={styles.label} onClick={() => history.push('/our-team/ahmad-kamal')}><span
              style={styles.name}>Ahmad Kamal Sheikh Awab</span><br />Chief Executive
              Officer</Label>
            <Label style={styles.label} onClick={() => history.push('/our-team/paul-kuan')}><span
              style={styles.name}>Paul Kuan</span><br />Director</Label>
          </div>
        </InlineImage>
        <MainImage img="/about.jpg" className="visible-xs">
          <div />
          <h2>About Premium Capital Partners</h2>
          <div />
        </MainImage>
        <Grid>
          <Row>
            <Col xs={12}>
              <p>
                Premium Capital Partners was established with the goal of delivering <strong>innovative
                business financing solutions</strong> to the Malaysian market. We are committed to building a
                portfolio of non-traditional business financing products that can unlock
                transformative financial opportunity for Malaysian businesses. Our model builds on a
                team with extensive international industry experience to deliver global excellence
                for the local market.
              </p>
              <p>
                Premium Capital Partners is fully licensed, authorised and approved by the Ministry
                of Housing & Local Government under the Moneylenders Act 1951.The company is guided
                by a management team with over 50 years' experience across a diverse range of
                financial markets. We understand the investment environment and know how to operate
                in a way that maximises the potential to deliver positive outcomes for our customers
                and partners.Our flagship Premium Funding product is a realisation of our drive to
                deliver <strong>innovative business financing solutions</strong> that address significant unmet
                market needs. Unlike conventional institutions, Premium Capital Partners is able to
                adapt to a changing market, delivering solutions that fit the modern business
                environment while ensuring the flexibility to meet the requirements of tomorrow's
                business needs. In a landscape that is always evolving, we're committed to
                delivering financial solutions that evolve to keep pace.
              </p>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default ProductInfo;



// WEBPACK FOOTER //
// ./src/screens/AboutUs.js